const GET_CANVAS = 'getCanvas';

// zoneOfRelevanceStore
const FETCH_ZOR_CARDS = 'fetchZorCards';
const FETCH_ZOR_TABS = 'fetchZorTabs';

// loyaltyStore
const FETCH_REWARD_POINTS = 'fetchRewardPoints';

export { GET_CANVAS, FETCH_ZOR_CARDS, FETCH_ZOR_TABS, FETCH_REWARD_POINTS };
